import Link from "next/link";
import Image from "next/legacy/image";
import { useRouter } from "next/router";
import { useState } from "react";
import { logClickLnbItem } from "@/businessLogics/_common/logging";

import { logOut } from "@/businessLogics/_common/auth/login";
import { useScrollDirection } from "@/businessLogics/_common/logging/useScrollDirection";
import { useWindowScrollY } from "@/businessLogics/_common/util-browser";
import { LandingPageMobileLnbMolecule } from "@/components/molecules/LandingPageMolecules/LandingPageMobileLnbMolecule";
import { lnbItems } from "@/models/lnb";

import * as S from "./LandingPageLnbMolecule.style";
import logo_black from "public/images/landing/lnb/logo_web_GNB_black.svg";
import hanghae_pm_logo from "/public/images/logo/hanghae_logo.png";

const LandingPageLnbMolecule = ({ userInfo }: { userInfo?: UserInfo }) => {
  const router = useRouter();
  const next = encodeURIComponent(router.asPath);
  const scrollUp = useScrollDirection();
  const scrollTop = useWindowScrollY() === 0;
  const [isSideMenuOpen, setIsSideMenuOpen] = useState<boolean>(false);

  function loginHandler(e) {
    const btnText = e.target.innerHTML;
    const url = btnText === "로그인" ? `/login?next=${next}` : "/";
    logClickLnbItem(btnText, url);
    e.target.innerHTML === "로그아웃"
      ? logOut()
      : router.push(`/login?next=${next}`);
  }

  // function goHome() {
  //   logClickLnbItem("로고", "/");
  //   router.push("/");
  // }

  return (
    <S.Background
      isScrollUp={scrollUp}
      scrollTop={scrollTop}
      isSideMenuOpen={isSideMenuOpen}
    >
      <S.Wrapper scrollTop={scrollTop}>
        <S.LeftItem>
          <Image
            src={hanghae_pm_logo}
            alt="logo"
            // onClick={goHome}
            priority
            width={76}
            height={26}
          />
          {/*<S.LnbItems>*/}
          {/*  {courseLnbItems.map(({ text, link, courseName, badgeText }) => (*/}
          {/*    <CustomLink*/}
          {/*      key={text}*/}
          {/*      url={link}*/}
          {/*      userInfo={userInfo}*/}
          {/*      course={courseName}*/}
          {/*    >*/}
          {/*      <S.LnbItem*/}
          {/*        isClicked={router.asPath === `/${courseName}`}*/}
          {/*        onClick={() => logClickLnbItem(text, link)}*/}
          {/*      >*/}
          {/*        {text}*/}
          {/*        /!* chip css *!/*/}
          {/*        /!*{badgeText.length ? (*!/*/}
          {/*        /!*  <S.AlimBadge isAlimStep={link === "alim"}>*!/*/}
          {/*        /!*    {badgeText}*!/*/}
          {/*        /!*  </S.AlimBadge>*!/*/}
          {/*        /!*) : null}*!/*/}
          {/*      </S.LnbItem>*/}
          {/*    </CustomLink>*/}
          {/*  ))}*/}
          {/*</S.LnbItems>*/}
        </S.LeftItem>
        <S.LnbItems>
          {/* {lnbItems.map((item) => (
            <Link
              href={item.link}
              key={item.text}
              target={item.isOutsideLink ? "_blank" : "_self"}
              rel="noreferrer"
              onClick={() =>
                logClickLnbItem(item.text, item.link, item.isOutsideLink)
              }
            >
              {item.text}
            </Link>
          ))}
          <S.VerticalLine></S.VerticalLine> */}
          <span onClick={loginHandler}>{userInfo ? "로그아웃" : "로그인"}</span>
        </S.LnbItems>
        <LandingPageMobileLnbMolecule
          userInfo={userInfo}
          isSideMenuOpen={isSideMenuOpen}
          setIsSideMenuOpen={setIsSideMenuOpen}
        />
      </S.Wrapper>
    </S.Background>
  );
};

export default LandingPageLnbMolecule;
